import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { AdminProvider } from './context/AdminContext';

// Public components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

// Public pages
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import SubProduct from './pages/SubProduct';
import Contact from './pages/Contact';

// Admin
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminProducts from './admin/AdminProducts';
import AdminSubProducts from './admin/AdminSubProducts';
import AdminContent from './admin/AdminContent';
import ProtectedRoute from './admin/ProtectedRoute';

import './App.css';

function PublicLayout() {
  React.useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:category" element={<SubProduct />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <AdminProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Admin Login */}
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Admin Panel (protected) */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Navigate to="/admin/dashboard" replace />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="sub-products" element={<AdminSubProducts />} />
                <Route path="content" element={<AdminContent />} />
              </Route>

              {/* Public Website */}
              <Route path="/*" element={<PublicLayout />} />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AdminProvider>
  );
}

export default App;
